import React, { useEffect, useState } from 'react';
import { convertTimestampToDateTime } from '../../helper/helper';
import PurchaseConfirmation from './PurchaseConfirmation';
import Footer from '../../components/Common/Footer';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import Heading from '../../components/Common/Heading';
import Guide from '../../components/Common/Guide';
import PaginationButtons from '../../components/Common/Pagination';
import { OrderDetailsModel } from '../../interfaces/order.interface';
import { getOrdersHistory, handleResendConfirmationEmail } from './services/OrderHistory.service';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import OrderHistoryTable from './components/OrderHistoryTable';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import NoItemsFound from '../../components/NoItemsFound/NoItemsFound';
import { UserRoleEnum } from '../../interfaces/user.interface';
import { useNavigate } from 'react-router-dom';

const OrderHistory = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const navigateTo = useNavigate();
  const [orderHistory, setOrderHistory] = useState<OrderDetailsModel[] | null>(null);
  const [loader, setLoader] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number | null>(null);
  const [resendEmailLoader, setResendEmailLoader] = useState<string | null>(null);
  const [showPurchaseConfirmation, setShowPurchaseConfirmation] = useState<boolean>(false);
  const [selectedOrder, setSelectedOrder] = useState<OrderDetailsModel | null>(null);

  useEffect(() => {
    if (user?.role && [UserRoleEnum.student, UserRoleEnum.teacher].includes(user?.role!)) {
      navigateTo('/');
    }
  }, [user]);

  const fetchOrderHistory = async () => {
    try {
      setLoader(true);
      const data = await getOrdersHistory(user?.email!, currentPage);
      if (data) {
        setOrderHistory(data.orders);
        setTotalPages(data.totalPages);
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  const resendConfirmationEmail = async (orderId: string) => {
    try {
      setResendEmailLoader(orderId);
      const order = orderHistory?.find((obj) => obj?.id === orderId);
      if (order) {
        await handleResendConfirmationEmail(user?.email!, orderId, order?.orderType);
      }
    } catch (error) {
    } finally {
      setResendEmailLoader(null);
    }
  };

  useEffect(() => {
    fetchOrderHistory().then();
  }, [user, currentPage]);
  const handlePageChange = (page: number | any) => {
    setCurrentPage(page);
  };

  const handleEyeClick = (order: OrderDetailsModel) => {
    setSelectedOrder(order);
    setShowPurchaseConfirmation(true);
  };

  const handleCloseConfirmationEmail = () => {
    setShowPurchaseConfirmation(false);
  };

  const calculateBookPurchaseTotalAmount = (order: OrderDetailsModel): number => {
    let total: number =
      +(+order?.price - +(order?.couponDiscount || 0) + +(order?.shippingAmount ?? 0)).toFixed(2) || 0;

    // const subTotal: number = +(parseFloat(order?.price) + parseFloat(order?.additionalPageCost?.toString() || '0')).toFixed(2);
    if (total <= 0) {
      total = 0;
    }
    return total;
  };

  return (
    <div>
      <div className="App">
        <NavigationBar />
        <div
          className={`bg-storytan ${
            showPurchaseConfirmation ? ' h-max' : 'p-4 h-[73rem] lg:h-[86vh] '
          }  mx-auto overflow-hidden  `}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
            <div className=" flex items-center align-end mb-4">
              <Heading title="My Orders" />
              <div>
                <Guide />
              </div>
            </div>
            {showPurchaseConfirmation ? (
              <PurchaseConfirmation onClose={handleCloseConfirmationEmail} order={selectedOrder} />
            ) : (
              <>
                {loader ? (
                  <LoadingSpinner />
                ) : (
                  <>
                    {orderHistory?.length! > 0 ? (
                      <div>
                        <div className="w-full h-[100%] lg:h-[60vh] overflow-auto ">
                          <OrderHistoryTable
                            orderHistory={orderHistory}
                            convertTimestampToDateTime={convertTimestampToDateTime}
                            calculateBookPurchaseTotalAmount={calculateBookPurchaseTotalAmount}
                            handleEyeClick={handleEyeClick}
                            resendConfirmationEmail={resendConfirmationEmail}
                            resendEmailLoader={resendEmailLoader}
                          />
                        </div>

                        <div className="flex justify-end sm:justify-end mt-0 md:mt-2 lg:mt-0 gap-2">
                          {totalPages && totalPages > 1 && (
                            <PaginationButtons
                              totalPages={totalPages}
                              currentPage={currentPage}
                              handlePageChange={handlePageChange}
                            />
                          )}
                        </div>
                      </div>
                    ) : (
                      <NoItemsFound message="No Payment History Found" />
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default OrderHistory;
